"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCobalt = function IconCobalt(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M10 8h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4zm14.088 19.784c-2.96 0-5.088-2.336-5.088-5.392S17.128 19 20.088 19c1.424 0 2.736.496 3.632 1.312l-.816 1.408a3.96 3.96 0 0 0-2.8-1.152c-1.952 0-3.456 1.552-3.456 3.824s1.504 3.824 3.456 3.824a3.96 3.96 0 0 0 2.8-1.152l.816 1.408c-.896.816-2.208 1.312-3.632 1.312m8.323-.064c-2.128 0-3.696-1.632-3.696-3.856s1.568-3.856 3.696-3.856c2.144 0 3.712 1.632 3.712 3.856s-1.568 3.856-3.712 3.856m0-6.304c-1.28 0-2.176 1.008-2.176 2.448s.896 2.448 2.176 2.448c1.296 0 2.176-1.008 2.176-2.448s-.88-2.448-2.176-2.448",
    clipRule: "evenodd"
  })));
};

export { IconCobalt, IconCobalt as default };
